import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'UPDATE_PII';

const useUpdateEdePiiMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const UPDATE_EDE_PII_MUTATION = gql`
    mutation UpdateEdePii($appID: ID!, $payload: EdePiiInput!) {
      ${queryName} (appID: $appID, payload: $payload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(UPDATE_EDE_PII_MUTATION, options);
};

export default useUpdateEdePiiMutation;
